import React from 'react';
import naturopathyImage from '../assets/images/services/naturopathy.jpg'; // TODO: Add this image to services/ or replace with existing like mud-therapy.jpg

function Naturopathy() {
  return (
    <div className='container page-container'>
      <div className="content-text-fluid">
        <div style={{ flex: 1 }}>
          <h1 style={{ color: '#d87d0a', fontWeight: 'bold', marginBottom: '20px' }}>Naturopathy</h1>
          <p>
            Naturopathy is a holistic healing system that supports the body's innate ability to heal itself through natural therapies and lifestyle modifications. At Kalinga Ashram, we embrace naturopathy as a comprehensive approach to wellness that treats the whole person - body, mind, and spirit.
          </p>
          <p>
            Our naturopathy practice incorporates five key natural elements - Earth (mud therapy), Water (hydrotherapy), Air (pranayama), Fire (sunbathing), and Ether (fasting and positive mental attitude). These time-tested methods work in harmony with nature to restore balance and vitality.
          </p>
          <p>
            Through naturopathy at Kalinga Ashram, visitors experience:
          </p>
          <ul>
            <li>Detoxification and cleansing programs</li>
            <li>Personalized diet counseling with natural foods</li>
            <li>Hydrotherapy treatments</li>
            <li>Mud and clay therapies</li>
            <li>Breathing exercises and yoga therapy</li>
            <li>Stress management and mental health support</li>
          </ul>
          <p>
            Naturopathy teaches us to live in rhythm with nature's cycles, listen to our body's wisdom, and cultivate sustainable health practices. It empowers individuals to take responsibility for their well-being through simple, natural, and accessible methods.
          </p>
          <p>
            Discover the healing power of nature and awaken your body's natural healing potential at Kalinga Ashram.
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <img src={naturopathyImage} alt="Naturopathy" style={{ width: '100%', borderRadius: '8px' }} />
        </div>
      </div>
    </div>
  );
}

export default Naturopathy;
